/* ============================================
   REEYEE THEME - JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {
  initMobileNav();
  initSearchOverlay();
  initProductTabs();
  initReviewsCarousel();
  initMaterialSlider();
  initLocalizationDropdowns();
});

/* --- Mobile Navigation --- */
function initMobileNav() {
  const toggleBtns = document.querySelectorAll('[data-action="toggle-mobile-nav"]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  if (!mobileNav) return;

  toggleBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const isHidden = mobileNav.hidden;
      mobileNav.hidden = !isHidden;
      document.body.style.overflow = isHidden ? 'hidden' : '';
    });
  });

  mobileNav.addEventListener('click', (e) => {
    if (e.target === mobileNav) {
      mobileNav.hidden = true;
      document.body.style.overflow = '';
    }
  });
}

/* --- Search Overlay --- */
function initSearchOverlay() {
  const toggleBtns = document.querySelectorAll('[data-action="toggle-search"]');
  const overlay = document.querySelector('[data-search-overlay]');
  if (!overlay) return;

  toggleBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const isHidden = overlay.hidden;
      overlay.hidden = !isHidden;
      document.body.style.overflow = isHidden ? 'hidden' : '';
      if (isHidden) {
        overlay.querySelector('input')?.focus();
      }
    });
  });
}

/* --- Product Tabs --- */
function initProductTabs() {
  document.querySelectorAll('.featured-products').forEach(section => {
    const tabs = section.querySelectorAll('.featured-products__tab');
    const panels = section.querySelectorAll('.featured-products__panel');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const index = tab.dataset.tabIndex;

        tabs.forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(p => p.classList.remove('is-active'));

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        const panel = section.querySelector(`[data-panel-index="${index}"]`);
        if (panel) panel.classList.add('is-active');
      });
    });
  });
}

/* --- Reviews Carousel --- */
function initReviewsCarousel() {
  document.querySelectorAll('[data-reviews-carousel]').forEach(carousel => {
    const track = carousel.querySelector('.reviews-carousel__track');
    const prevBtn = carousel.querySelector('[data-carousel-prev]');
    const nextBtn = carousel.querySelector('[data-carousel-next]');
    if (!track) return;

    const getSlideWidth = () => {
      const slide = track.querySelector('.reviews-carousel__slide');
      if (!slide) return 0;
      return slide.offsetWidth + 30; // gap
    };

    prevBtn?.addEventListener('click', () => {
      track.scrollBy({ left: -getSlideWidth(), behavior: 'smooth' });
    });

    nextBtn?.addEventListener('click', () => {
      track.scrollBy({ left: getSlideWidth(), behavior: 'smooth' });
    });
  });
}

/* --- Material Slider --- */
function initMaterialSlider() {
  document.querySelectorAll('[data-material-slider]').forEach(slider => {
    const slides = slider.querySelectorAll('.material-showcase__slide');
    const dots = slider.querySelectorAll('.material-showcase__dot');

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const index = dot.dataset.slideIndex;

        slides.forEach(s => s.classList.remove('is-active'));
        dots.forEach(d => d.classList.remove('is-active'));

        slides[index]?.classList.add('is-active');
        dot.classList.add('is-active');
      });
    });

    // Auto-rotate every 5s
    if (slides.length > 1) {
      let current = 0;
      setInterval(() => {
        current = (current + 1) % slides.length;
        slides.forEach(s => s.classList.remove('is-active'));
        dots.forEach(d => d.classList.remove('is-active'));
        slides[current]?.classList.add('is-active');
        dots[current]?.classList.add('is-active');
      }, 5000);
    }
  });
}

/* --- Localization Dropdowns --- */
function initLocalizationDropdowns() {
  document.querySelectorAll('.header-localization__trigger').forEach(trigger => {
    const dropdown = trigger.nextElementSibling;
    if (!dropdown) return;

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', !isExpanded);
      dropdown.hidden = isExpanded;
    });

    document.addEventListener('click', () => {
      trigger.setAttribute('aria-expanded', 'false');
      dropdown.hidden = true;
    });
  });
}
